<template>
    <div>
        <h5 class="mt-1 mb-3">{{ $t('general_information').toUpper() }}</h5>
        <b-row>
            <b-col cols="12" lg="12">
                <b-card :header="$t('staff_information')" class="soft mb-5">
                    <b-row>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('username') }}</label>
                                <div>{{ staffInformation.username ? staffInformation.username : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('title1') }}</label>
                                <div>{{ staffInformation.title ? staffInformation.title : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('name') }}</label>
                                <div>{{ staffInformation.name ? staffInformation.name : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('surname') }}</label>
                                <div>{{ staffInformation.surname || "-" }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('email') }}</label>
                                <div>{{ staffInformation.email }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('personal_email') }}</label>
                                <div>{{ staffInformation.personal_email }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('gsm_no') }}</label>
                                <div>{{ staffInformation.mobile_tel ? staffInformation.mobile_tel : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('mobile_tel_country_code') }}</label>
                                <div>{{ staffInformation.mobile_tel_country_code ? staffInformation.mobile_tel_country_code : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('Staff Id') }}</label>
                                <div>{{ staffInformation.registration_number ? staffInformation.registration_number : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                        <div class="label-as-input-div">
                            <label>{{ $t('faculty') }}</label>
                            <div>{{ staffInformation.faculty_code ? staffInformation.faculty_code : '-' }}</div>
                        </div>
                    </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('department') }}</label>
                                <div>{{ staffInformation.department_code ? staffInformation.department_code : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('program_code') }}</label>
                                <div>{{ staffInformation.program_code ? staffInformation.program_code : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('academic_department') }}</label>
                                <div>{{ staffInformation.academic_department_code ? staffInformation.academic_department_code : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('unit') }}</label>
                                <div>{{ staffInformation.unit ? staffInformation.unit : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('office') }}</label>
                                <div>{{ staffInformation.office ? staffInformation.office : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('workload') }}</label>
                                <div>{{ staffInformation.contract_type ? staffInformation.contract_type : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('working_status') }}</label>
                                <div>{{ staffInformation.working_status ? staffInformation.working_status : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('start_date') }}</label>
                                <div>{{ staffInformation.start_date ? staffInformation.start_date : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('end_date') }}</label>
                                <div>{{ staffInformation.end_date ? staffInformation.end_date : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('date_of_birth') }}</label>
                                <div>
                                    {{ this.getObjectValue(staffInformation, 'birthdate') }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('gender') }}</label>
                                <div>
                                    {{ getObjectValue(staffInformation, 'gender') }}
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
                <b-button variant="primary"
                          @click="updateFormShow"
                          v-if="checkPermission('staff_update')">
                    {{ $t('edit') }}
                </b-button>
            </b-col>

        </b-row>
        <CommonModal ref="formModal"
                     size="xl"
                     @bHideModalHeaderClose="clearFormData()"
                     :onHideOnlyX="true"
                     v-if="checkPermission('staff_update')">
            <template v-slot:CommonModalTitle>
                {{ $t('edit').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :staff-information="staffInformation"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    import UpdateForm from "@/modules/staff/pages/Information/components/generalInformation/UpdateForm.vue";

    export default {
        components: {UpdateForm},
        props: {
            staffInformation: {
                type: Object,
                default: null
            }
        },
        data(){
            return{
                formProcess:null
            }
        },
        methods:{
            metaInfo() {
                return {
                    title: this.$t('general_information')
                }
            },
            clearFormData() {
                this.formProcess = null
            },
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            },
        }
    }
</script>

